import SideBar from 'pages/SideBar/SideBar';

export const ProtectedRouteOutlet = () => {
  return (
    <>
      <SideBar />
    </>
  );
};
